import { render } from "./CustomLabelSizesButton.vue?vue&type=template&id=6ceab16a&scoped=true&ts=true"
import script from "./CustomLabelSizesButton.vue?vue&type=script&lang=ts"
export * from "./CustomLabelSizesButton.vue?vue&type=script&lang=ts"

import "./CustomLabelSizesButton.vue?vue&type=style&index=0&id=6ceab16a&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceab16a"]])

export default __exports__